import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/base/store/findByPage",
        method: "post",

        data
    });
}
/**
 * 保存门店
 * @param {*} data
 */
export function SaveStoreInfo(data) {
  return request({
      url: "/base/store/saveStoreInfo",
      method: "post",

      data
  });
}
/**
 * 查询单条门店信息
 * @param {*} data
 */
export function FindStoreInfoById(data) {
  return request({
      url: "/base/store/findStoreInfoById",
      method: "post",

      data
  });
}
/**
 * 删除门店信息
 * @param {*} data
 */
export function DeleteStoreInfoByIds(data) {
  return request({
      url: "/base/store/deleteStoreInfoByIds",
      method: "post",

      data
  });
}
/**
 * 删除门店信息
 * @param {*} data
 */
export function FindStoreInfoAll(data) {
  return request({
      url: "/base/store/findStoreInfoAll",
      method: "post",
      data
  });
}

